import { takeLatest, put, all } from 'redux-saga/effects';
import { openPropertySuccess } from './actions';

export function* fnOpenProperty({ payload }) {
  try {
    if (payload) {
      yield put(openPropertySuccess(payload));
    }
  } catch (error) {
    console.error(error);
  }
}

export default all([takeLatest('@property/OPEN_PROPERTY', fnOpenProperty)]);
